import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse, OTPType } from '@/interfaces';

class VerificationsService {
	constructor(private client: AxiosInstance) {}

	async verifyNumber(type: OTPType): Promise<HttpResponse<{ data: string }>> {
		return this.client.get(`/otp/send/${type}`);
	}

	async validatePhoneOtp(
		code: string,
		type: OTPType
	): Promise<HttpResponse<{ message: string }>> {
		return this.client.post('/otp/validate', { otp: code, type_otp: type });
	}

	async resendEmailVerification(): Promise<
		HttpResponse<{ data: { message: string } }>
	> {
		return this.client.post('/user/resend-additional-email-verification');
	}

	async validateEmailOtp(code: string): Promise<HttpResponse<any>> {
		return this.client.post('/user/verify-addition-email', { code });
	}
}

export const verificationsService = new VerificationsService(axiosClient);
